import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { Tooltip } from "@/components/Tooltip/Tooltip";
import { ScheduleFailureCategory } from "@/enum/schedule.enum";

interface StepFailureNoteProps {
	failureCategory?: ScheduleFailureCategory | null;
}

/**
 * The campaign-flow node's line for a step that failed to send, replacing the green "…sent" line.
 * The API only tells us the failure category — the raw provider payload never leaves the server —
 * so the wording lives in `outbox.failure.*` and is shared with the Outbox lead card's tag.
 */
export const StepFailureNote: FunctionComponent<StepFailureNoteProps> = ({ failureCategory }) => {
	const { t } = useTranslation();
	const category = failureCategory ?? ScheduleFailureCategory.UNKNOWN;

	return (
		<Tooltip
			content={
				<div className="flex flex-col gap-1 text-xs text-text-meta">
					<span>{t(`outbox.failure.${category}.message`)}</span>
					<span>{t(`outbox.failure.${category}.actionHint`)}</span>
				</div>
			}
			direction="bottom"
		>
			<div className="cursor-help text-xs text-status-error">
				{t(`outbox.failure.${category}.label`, { step: t("outbox.failure.stepFallback") })}
			</div>
		</Tooltip>
	);
};
